import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '../src/containers/app';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css'
import '../src/css/font-awesome.min.css'
import '../src/css/flaticon.css'
import '../src/css/odometer-theme-default.css'
import '../src/css/animate.css'
import './style.scss';

import { Provider } from 'react-redux'
import store from './store'

const app = (
    <Provider store={store}>
        <App />
    </Provider>
);

// react-snap pre-renders each route to static HTML at build time. When the
// browser loads that pre-rendered markup we hydrate it; otherwise render fresh.
const rootElement = document.getElementById('root');
if (rootElement.hasChildNodes()) {
    ReactDOM.hydrateRoot(rootElement, app);
} else {
    ReactDOM.createRoot(rootElement).render(app);
}

// Send Core Web Vitals (LCP, CLS, INP, FCP, TTFB) to GA4 when it's loaded.
reportWebVitals((metric) => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        window.gtag('event', metric.name, {
            value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
            metric_id: metric.id,
            metric_value: metric.value,
            non_interaction: true,
        });
    }
});
